<template>
  <div class="STable">
    <div
      class="query"
      v-if="queryGeneralFields.length > 0 || queryAdvancedFields.length > 0"
    >
      <el-form
        :inline="true"
        :ref="queryForm"
        :model="queryForm"
        :label-width="labelWidth"
      >
        <div class="fields">
          <div class="general">
            <el-form-item
              v-for="(item, index) in queryGeneralFields"
              v-bind:key="index"
              :label="item.label"
              :prop="item.prop"
              class="query-from-item"
            >
              <el-select
                v-if="item.type === 'select'"
                filterable
                v-model="queryForm[item.prop]"
                :placeholder="item.placeholder"
              >
                <el-option
                  v-for="(option, index) in item.data"
                  v-bind:key="index"
                  :label="option.label"
                  :value="option.value"
                ></el-option>
              </el-select>
              <el-switch
                v-else-if="item.type === 'switch'"
                v-model="queryForm[item.prop]"
                :placeholder="item.placeholder"
              ></el-switch>
              <el-date-picker
                v-else-if="item.type === 'date'"
                :type="item.option.type"
                v-model="queryForm[item.prop]"
                :placeholder="item.placeholder"
                value-format="yyyy-MM-dd HH:mm:ss"
                :editable="false"
              ></el-date-picker>
              <el-date-picker
                v-else-if="item.type === 'date2'"
                v-model="queryForm[item.prop]"
                :type="item.option.type"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width:360px;"
              >
              </el-date-picker>
              <el-date-picker
                v-else-if="item.type === 'date3'"
                :type="item.option.type"
                v-model="queryForm[item.prop]"
                :placeholder="item.placeholder"
                value-format="yyyy-MM-dd"
                :editable="false"
              ></el-date-picker>
              <cn-region-picker
                v-else-if="item.type === 'pickCity'"
                v-model="queryForm[item.prop]"
                :placeholder="item.placeholder"
              ></cn-region-picker>
              <SCity
                v-else-if="item.type === 'city'"
                v-model="queryForm[item.prop]"
              ></SCity>

              <el-cascader
                v-else-if="item.type === 'cascader'"
                v-model="queryForm[item.prop]"
                style="width: 90%; margin-left: 1%"
                :placeholder="item.placeholder"
                :options="item.data"
                :props="item.props"
                clearable
                filterable
              ></el-cascader>
              <el-cascader
                v-else-if="item.type === 'cascadersingle'"
                :options="item.data"
                v-model="queryForm[item.prop]"
                :placeholder="item.placeholder"
                :show-all-levels="false"
                :props="item.props"
                clearable
                filterable
              ></el-cascader>
              <div class="ScopeBox" v-else-if="item.type === 'scopeBox'">
                <el-input
                  class="scope-box-input1"
                  ref="scopeBoxInputStart"
                  placeholder=""
                  v-model="queryForm[item.minProp]"
                  v-on:input="checkScopeBoxStart"
                >
                </el-input>
                <span class="scope-box-span1">{{ item.middleLabel }}</span>
                <el-input
                  placeholder=""
                  v-model="queryForm[item.maxProp]"
                  class="scope-box-input2"
                  ref="scopeBoxInputEnd"
                  v-on:input="checkScopeBoxEnd(queryForm[item.maxProp])"
                >
                </el-input>
                <span class="scope-box-span2">{{ item.unit }}</span>
              </div>
              <div v-else-if="item.type === 'hide'">
                <el-input
                  v-show="false"
                  v-model="queryForm[item.prop]"
                  :placeholder="item.placeholder"
                ></el-input>
              </div>
              <el-input
                v-else
                v-model="queryForm[item.prop]"
                :placeholder="item.placeholder"
              ></el-input>
            </el-form-item>
          </div>
          <div class="advanced" v-if="queryModel === 'advanced'">
            <el-form-item
              v-for="(item, index) in queryAdvancedFields"
              v-bind:key="index"
              :label="item.label"
              :prop="item.prop"
              class="query-from-item"
            >
              <el-select
                v-if="item.type === 'select'"
                v-model="queryForm[item.prop]"
                :placeholder="item.placeholder"
              >
                <el-option
                  v-for="(option, index) in item.data"
                  v-bind:key="index"
                  :label="option.label"
                  :value="option.value"
                >
                  <span style="float: left">{{ option.label }}</span>
                  <span
                    v-show="item.select"
                    style="float: left; margin-left: 15px"
                    >{{ option.value }}</span
                  >
                </el-option>
              </el-select>
              <el-switch
                v-else-if="item.type === 'switch'"
                v-model="queryForm[item.prop]"
                :placeholder="item.placeholder"
              ></el-switch>
              <el-date-picker
                v-else-if="item.type === 'date'"
                :type="item.option.type"
                v-model="queryForm[item.prop]"
                :placeholder="item.placeholder"
                value-format="yyyy-MM-dd HH:mm:ss"
                :editable="false"
              ></el-date-picker>
              <el-date-picker
                v-else-if="item.type === 'date3'"
                :type="item.option.type"
                v-model="queryForm[item.prop]"
                :placeholder="item.placeholder"
                value-format="yyyy-MM-dd"
                :editable="false"
              ></el-date-picker>
              <el-date-picker
                v-else-if="item.type === 'date2'"
                v-model="queryForm[item.prop]"
                :type="item.option.type"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
              <SCity
                v-else-if="item.type === 'city'"
                v-model="queryForm[item.prop]"
              ></SCity>
              <el-cascader
                v-else-if="item.type === 'cascader'"
                v-model="queryForm[item.prop]"
                style="width: 90%; margin-left: 1%"
                :placeholder="item.placeholder"
                :options="item.data"
                :props="item.props"
                clearable
                filterable
              ></el-cascader>
              <el-cascader
                v-else-if="item.type === 'cascadersingle'"
                :options="item.data"
                v-model="queryForm[item.prop]"
                :placeholder="item.placeholder"
                :show-all-levels="false"
                :props="item.props"
              ></el-cascader>
              <div class="ScopeBox" v-else-if="item.type === 'scopeBox'">
                <el-input
                  class="scope-box-input1"
                  ref="scopeBoxInputStart"
                  placeholder=""
                  v-model="queryForm[item.minProp]"
                  v-on:input="checkScopeBoxStart"
                >
                </el-input>
                <span class="scope-box-span1">{{ item.middleLabel }}</span>
                <el-input
                  placeholder=""
                  v-model="queryForm[item.maxProp]"
                  class="scope-box-input2"
                  ref="scopeBoxInputEnd"
                  v-on:input="checkScopeBoxEnd(queryForm[item.maxProp])"
                >
                </el-input>
                <span class="scope-box-span2">{{ item.unit }}</span>
              </div>
              <el-input
                v-else
                v-model="queryForm[item.prop]"
                :placeholder="item.placeholder"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="btns">
          <el-form-item>
            <el-button
              class="model resetbtn"
              v-if="queryAdvancedFields.length > 0"
              @click="switchQueryModel"
              >{{ queryModel == "general" ? "更多" : "隐藏" }}</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              :type="tableBtnStyle ? 'primary' : 'success'"
              plain
              @click="queryTable"
              >查询</el-button
            >
            <el-button
              @click="resetForm()"
              :class="tableBtnStyle ? '' : 'resetbtn'"
              >重置</el-button
            >
          </el-form-item>
        </div>
        <div style="clear: both"></div>
      </el-form>
    </div>
    <div class="toolbar" v-if="toolbar.length > 0">
      <template v-for="(item, index) in toolbar">
        <template v-if="hasPermission(item.permission)">
          <el-upload
            v-if="item.isUpload"
            v-loading="item.option.loading"
            class="upload"
            :action="item.url"
            :show-file-list="false"
            :with-credentials="true"
            :on-success="item.option.onSuccess ? item.option.onSuccess : ''"
            :on-error="item.option.onError ? item.option.onError : ''"
            :on-progress="item.option.onProgress ? item.option.onProgress : ''"
            :before-upload="
              item.option.beforeUpload ? item.option.beforeUpload : ''
            "
            :headers="item.option.headers"
            v-bind:key="index"
          >
            <el-button :type="item.type" plain v-bind:key="index">{{
              item.label
            }}</el-button>
          </el-upload>
          <el-button
            v-else-if="
              (!item.isSelectRowShow && item.type2 != 'checkbox') ||
                (item.isSelectRowShow &&
                  multipleSelection.length > 0 &&
                  item.type2 != 'checkbox')
            "
            :type="item.type"
            plain
            :disabled="
              multipleSelection.length > 1 && item.onSelect
                ? false
                : item.disabled
            "
            @click="handleToolbar(item)"
            >{{ item.label }}
          </el-button>
          <el-checkbox
            v-if="item.selection && item.plantSelect"
            v-model="allCheck"
            @change="allCheckEvent"
            v-bind:key="index"
            >{{ item.label }}
          </el-checkbox>
        </template>
      </template>
      <template
        ><el-button
          type="danger"
          plain
          v-if="isSelected && multipleSelection.length > 0"
          v-bind:key="index"
        >
          已选 {{ total }} 条
        </el-button></template
      >
    </div>
    <div class="table">
      <el-table
        stripe
        :data="list"
        @selection-change="handleSelectionChange"
        :span-method="objectSpanMethod"
        border
        style="width: 100%"
        ref="queryTable"
        :row-key="getRowKey"
        @select-all="selectAll"
        @select="selectOne"
        @cell-click="cellClick"
        :max-height="tableHeight"
      >
        <el-table-column
          v-if="selection === true"
          type="selection"
          width="40"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column
          align="center"
          width="50"
          label="序号"
          v-if="isSupportRowspan"
        >
          <template slot-scope="scope" v-if="isSupportRowspan">{{
            scope.row.group + 1
          }}</template>
        </el-table-column>
        <el-table-column
          type="index"
          align="center"
          width="50"
          label="序号"
          v-else
        >
        </el-table-column>

        <el-table-column
          v-for="(column, index) in columns"
          v-bind:key="index"
          :fixed="column.fixed"
          :prop="column.prop"
          :label="column.label"
          :width="column.width"
          show-overflow-tooltip
          :align="column.align ? column.align : 'center'"
        >
          <template slot-scope="scope">
            <el-popover
              trigger="hover"
              placement="left"
              v-if="column.type == 'popover'"
            >
              <p>{{ scope.row[column.prop] }}</p>
              <span slot="reference" style="color:#00CC00;cursor: pointer;"
                >查看</span
              >
            </el-popover>
            <el-tag
              v-else-if="column.prop == 'offlineStatus'"
              :type="scope.row.offlineStatus === '离线' ? 'danger' : 'success'"
              disable-transitions
              >{{ scope.row.offlineStatus }}</el-tag
            >

            <div v-else>
              <!-- <span
                v-if="column.template"
                v-html="column.template(scope.$index, scope.row)"
                >{{ column.template(scope.$index, scope.row) }}</span
              > -->
              <span
                v-if="column.template"
                v-html="column.template(scope.$index, scope.row)"
              ></span>
              <div v-else>
                <el-input
                  v-if="
                    scope.row.isSupportCellEdit && column.prop == editCellProp
                  "
                  v-model="scope.row[column.prop]"
                  @blur="loseFcous(scope.$index, scope.row)"
                ></el-input>
                <el-switch
                  v-if="column.label == 'disable'"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  v-model="scope.row.disable"
                >
                </el-switch>
                <el-switch
                  v-if="column.type == 'switch'"
                  v-model="scope.row[column.prop]"
                  :active-value="column.activeValue"
                  :inactive-value="column.inactiveValue"
                  :disabled="column.disabled ? column.disabled : true"
                >
                </el-switch>
                <span v-else>{{ scope.row[column.prop] }}</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          v-if="handless && handless.btns"
          fixed="right"
          :label="cnames"
          align="center"
          :width="handless.width"
        >
          <template slot-scope="scope">
            <template v-for="(btn, index) in handless.btns">
              <template>
                <el-popover
                  placement="right"
                  width="240"
                  trigger="click"
                  v-bind:key="index"
                  @show="getDetail(scope.row.id)"
                >
                  <el-form :model="form" v-if="isPlant" label-width="80px">
                    <el-form-item label="状态">
                      <div style="margin-left: 80px">数量</div>
                    </el-form-item>
                    <el-form-item label="总数">
                      <div style="margin-left: 80px">{{ form.total }}</div>
                    </el-form-item>
                    <el-form-item label="空闲">
                      <div style="margin-left: 80px">{{ form.free }}</div>
                    </el-form-item>
                    <el-form-item label="充电中">
                      <div style="margin-left: 80px">{{ form.charging }}</div>
                    </el-form-item>
                    <el-form-item label="占用">
                      <div style="margin-left: 80px">{{ form.takeUp }}</div>
                    </el-form-item>
                    <el-form-item label="离线">
                      <div style="margin-left: 80px">{{ form.offLine }}</div>
                    </el-form-item>
                    <el-form-item label="故障">
                      <div style="margin-left: 80px">{{ form.broken }}</div>
                    </el-form-item>
                  </el-form>
                  <el-button slot="reference">查看</el-button>
                </el-popover>
              </template>
            </template>
          </template>
        </el-table-column>

        <el-table-column
          v-if="handles2 && handles2.btns"
          fixed="right"
          label="电桩状态"
          align="center"
          :width="handles2.width"
        >
          <template slot-scope="scope">
            <template v-for="(btn, index) in handles2.btns">
              <el-switch
                v-model="scope.row.enableStatus"
                @change="changeSwitch(scope.row.id)"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </template>
          </template>
        </el-table-column>

        <el-table-column
          v-if="handles && handles.btns"
          fixed="right"
          label="操作"
          align="center"
          :width="handles.width"
        >
          <template slot-scope="scope">
            <template v-for="(btn, index) in handles.btns">
              <template v-if="hasPermission(btn.permission)">
                <el-button
                  :style="btn.style"
                  v-show="btn.isShowFun ? btn.isShowFun(scope.row) : true"
                  @click="handleTable(btn, scope.$index, scope.row)"
                  type="text"
                  size="small"
                  :disabled="
                    btn.getLabelDisabled
                      ? btn.getLabelDisabled(scope.row)
                      : false
                  "
                  ><span
                    :style="
                      btn.getLabelStyle ? btn.getLabelStyle(scope.row) : ''
                    "
                    >{{
                      btn.getLabel ? btn.getLabel(scope.row) : btn.label
                    }}</span
                  ></el-button
                >
              </template>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="total > 0 && isShowPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: right;margin-top: 10px;"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "STable",
  props: {
    labelWidth: {
      type: String
    },
    tableHeight: {
      type: String
    },
    url: {
      type: String
    },
    selection: {
      type: Boolean,
      default() {
        return true;
      }
    },
    columns: {
      type: Array,
      default() {
        return [];
      }
    },
    listData: {
      type: Array,
      default() {
        return [];
      }
    },
    handle: {
      type: Object,
      default() {
        return {};
      }
    },
    handles: {
      type: Object,
      default() {
        return {};
      }
    },
    handles2: {
      type: Object,
      default() {
        return {};
      }
    },
    handless: {
      type: Object,
      default() {
        return {};
      }
    },
    query: {
      type: Array,
      default() {
        return [];
      }
    },
    toolbar: {
      type: Array,
      default() {
        return [];
      }
    },
    isShowPage: {
      type: Boolean,
      default() {
        return true;
      }
    },
    isNum: {
      type: Boolean,
      default() {
        return true;
      }
    },
    cnames: {
      type: String
    },
    keyprop: {
      type: String,
      default() {
        return "";
      }
    },
    editCellProp: {
      type: String
    },
    isSupportRowspan: {
      type: Boolean,
      default() {
        return false;
      }
    },
    isSupportCellEdit: {
      type: Boolean,
      default() {
        return false;
      }
    },
    spanColumns: {
      type: Number,
      default() {
        return 0;
      }
    },
    isPlant: {
      type: Boolean,
      default() {
        return true;
      }
    },
    tableBtnStyle: {
      type: Boolean,
      default() {
        return false;
      }
    },
    // 是否自动刷新页面
    autoRefresh: {
      type: Boolean,
      default: false
    },
    // 可自定义刷新间隔（默认3秒）
    refreshInterval: {
      type: Number,
      default: 5000
    }
  },
  components: {},
  data() {
    return {
      queryModel: "general",
      queryGeneralFields: [],
      queryAdvancedFields: [],
      queryForm: {},
      isSelected: false,
      allCheck: false,
      spanArr: [],
      pos: 0,
      list: [],
      multipleSelection: [],
      // multipleSelectionAll: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      allCheck: false,
      getRowKeys(row) {
        return row.id;
      },

      record: {},

      selectData2: {},
      selectData: [],

      form: {}
    };
  },
  beforeCreate() {},
  created: function() {
    if (this.query) {
      this.query.forEach((item, i) => {
        //设置默认日期
        if (item.haveDefaultDate && item.option.type == "date") {
          let currentDate = this.getNowFormatDate();
          this.$set(this.queryForm, item.prop, currentDate);
        }
        //设置默认选中项
        if (item.type == "select") {
          this.$set(this.queryForm, item.prop, item.defaultValue);
        }

        //从列表页面传参
        if (item.type == "hide") {
          this.$set(this.queryForm, item.prop, item.data);
        }
      });
      const fields = this.query;
      const totalLen = fields.length;
      let generalLen = 3;
      let advancedLen = totalLen;
      if (totalLen < 3) {
        generalLen = totalLen;
      }
      for (let i = 0; i < generalLen; i++) {
        this.queryGeneralFields.push(fields[i]);
      }
      if (generalLen < totalLen) {
        for (let i = generalLen; i < advancedLen; i++) {
          this.queryAdvancedFields.push(fields[i]);
        }
      }
    }
    if (this.isSupportCellEdit) {
      this.addField("isSupportCellEdit", this.listData);
    }

    if (this.listData && this.listData.length > 0) {
      if (this.isSupportRowspan) {
        this.getSpanArr(this.listData, this.keyprop);
      }
      this.list = this.listData;
    } else {
      this.queryTable();
    }
  },
  computed: {},
  mounted() {
    if (this.autoRefresh) {
      this.startAutoRefresh();
    }
  },
  methods: {
    startAutoRefresh() {
      this.timer = setInterval(() => {
        this.queryTable();
      }, this.refreshInterval);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    getDetail(val) {
      let data = {
        id: val
      };
      this.$store.dispatch("form/handle", {
        url: "/station/getGunStatus",
        data: data,
        method: "get",
        callback: resp => {
          this.form = resp;
        }
      });
    },
    changeSwitch(val) {
      console.log(val, "gai");
      this.$store.dispatch("form/handle", {
        url: "/owner-backend/owner/ownerStatus?id=" + val,
        data1: true,
        method: "post",
        callback: resp => {
          console.log(resp, "resp");
        },
        failCallback: resp => {
          console.log(resp, "err");
        }
      });
    },
    getRowKey(row) {
      return row.id;
    },
    getNowFormatDate() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + "-" + month + "-" + strDate;
      return currentdate;
    },
    addField(_field, forArray) {
      forArray.forEach((item, i) => {
        item[_field] = false;
      });
    },
    allCheckEvent() {
      if (this.allCheck) {
        this.list.forEach(row => {
          this.$refs.queryTable.toggleRowSelection(row, true);
        });
        this.isSelected = true;
        // console.log(111, this.isSelected);
      } else {
        this.isSelected = false;
        // console.log(222, this.isSelected);
        // this.$refs.queryTable.clearSelection();
      }
    },
    // 选所有取消，当前选中的数据应是：已翻页的两页数据-取消的那一行数据
    selectOne() {
      if (this.allCheck) {
        this.allCheck = false;
      }
    },
    //查询表单
    resetForm() {
      this.pageNo = 1;
      this.pageSize = 10;
      this.queryForm = {};
      this.queryTable();
    },
    switchQueryModel() {
      const queryModel = this.queryModel;
      if (queryModel == "general") {
        this.queryModel = "advanced";
      } else {
        this.queryModel = "general";
      }
    },

    //操作栏
    handleToolbar(option) {
      const o = this;
      const { isConfirm, confirmText, before } = option;
      const multipleSelection = this.multipleSelection;
      let data = {};
      if (before) data = before(multipleSelection);
      if (data == false) {
        return false;
      }
      if (isConfirm) {
        this.$confirm(
          confirmText ? confirmText : "此操作将永久删除该数据, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            closeOnClickModal: false,
            type: "warning"
          }
        ).then(() => {
          this.handleToolbarExecute(option, data);
          // this.$refs.queryTable.clearSelection();
        });
      } else {
        this.handleToolbarExecute(option, data);
      }
    },
    handleToolbarExecute(option, data) {
      const o = this;
      const { url, method, handle } = option;
      const multipleSelection = this.multipleSelection;
      if (url) {
        this.$store.dispatch("table/handle", {
          url: url,
          data: data,
          method: method,
          callback: function(resp) {
            handle(resp, o);
          }
        });
        // this.$refs.queryTable.clearSelection();
      } else {
        if (handle) handle(multipleSelection, o);
      }
    },

    //表格
    queryTable() {
      const { url } = this;
      if (!url) return;
      this.list = [];
      const queryData = this.queryForm;
      const params = {};
      for (const key in queryData) {
        let val = queryData[key];
        if (val instanceof Array) {
          val = val.join(",");
        }
        params[key] = val;
      }
      this.selectData = [];
      this.selectData2 = {};
      if (params.value) {
        this.selectData = params.value;
      }
      if (params) {
        this.selectData2.areaCode = params.areaCode;
        this.selectData2.operatorCode = params.operatorCode;
        this.selectData2.stationName = params.stationName;
      }

      this.$store.dispatch("table/page", {
        url: url,
        callback: data => {
          if (data != null) {
            this.total = data.count;
            this.pageNo = data.pageNo;
            this.pageSize = data.pageSize;
            if (this.isSupportCellEdit) {
              this.addField("isSupportCellEdit", data.list);
            }
            if (this.isSupportRowspan) {
              this.getSpanArr(data.list, this.keyprop);
            }
            // this.list = data.list;
            if (data.recordRespList) {
              this.list = data.recordRespList;
            } else {
              this.list = data.list;
            }
          }
        },
        data: {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          ...params
        }
      });
      // this.$refs.queryTable.clearSelection();
    },
    getQueryData() {
      return this.queryForm;
    },
    setQueryData(data) {
      this.queryForm = data;
    },
    setListData(data) {
      this.list = data;
    },
    // table表格中全选按钮
    selectAll() {
      // this.isSelected = false;
      this.allCheck = false;
    },
    handleSelectionChange(val) {
      this.isSelected = false;
      this.multipleSelection = val;
      // this.multipleSelection = this.reduceSame(val);
    },
    // reduceSame(arr) {
    //   let obj = {};
    //   return arr.reduce(function(prev, item) {
    //     obj[item.id] ? "" : (obj[item.id] = 1 && prev.push(item));
    //     return prev;
    //   }, []);
    // },

    // 支持翻页记忆
    handleCurrentChange(val) {
      this.pageNo = val;
      this.queryTable2();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryTable2();
    },
    queryTable2() {
      const { url } = this;
      this.list = [];
      const queryData = this.queryForm;
      const params = {};
      for (const key in queryData) {
        let val = queryData[key];
        if (val instanceof Array) {
          val = val.join(",");
        }
        params[key] = val;
      }

      this.selectData = [];
      this.selectData2 = {};
      if (params.value) {
        this.selectData = params.value;
      }
      if (params) {
        this.selectData2.areaCode = params.areaCode;
        this.selectData2.operatorCode = params.operatorCode;
        this.selectData2.stationName = params.stationName;
      }
      this.$store.dispatch("table/page", {
        url: url,
        callback: data => {
          this.total = data.count;
          this.pageNo = data.pageNo;
          this.pageSize = data.pageSize;
          if (this.isSupportCellEdit) {
            this.addField("isSupportCellEdit", data.list);
          }
          if (this.isSupportRowspan) {
            this.getSpanArr(data.list, this.keyprop);
          }
          this.list = data.list;
        },
        data: {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          ...params
        }
      });
    },
    handleTable(option, index, record) {
      this.record = record;
      const o = this;
      const { isConfirm, confirmText, before } = option;
      let data = {};
      if (before) data = before(index, record);
      if (data == false) {
        return false;
      }
      if (isConfirm) {
        this.$confirm(
          confirmText ? confirmText : "此操作将永久删除该数据, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            closeOnClickModal: false,
            type: "warning"
          }
        ).then(() => {
          this.handleTableExecute(option, record, data);
          if (this.$refs.queryTable) this.$refs.queryTable.clearSelection();
        });
      } else {
        this.handleTableExecute(option, record, data);
      }
    },
    handleTableExecute(option, record, data) {
      const o = this;
      const { url, method, handle } = option;
      if (url) {
        this.$store.dispatch("table/handle", {
          url: url,
          data: data,
          method: method,
          callback: function(resp) {
            handle(resp, o);
          }
        });
        if (this.$refs.queryTable) this.$refs.queryTable.clearSelection();
      } else {
        if (handle) handle(record, o);
      }
    },
    getRecord() {
      return this.record;
    },

    hasPermission(permission) {
      if (!permission) {
        return true;
      }
      let flag = false;
      const menus = this.$store.state.login.menu;
      for (let i = 0; i < menus.length; i++) {
        const menu = menus[i];
        if (menu == permission) {
          flag = true;
          break;
        }
      }
      return flag;
    },

    getSpanArr(data, keyprop) {
      this.spanArr = [];
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
          data[i].group = i;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i][keyprop] === data[i - 1][keyprop]) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
            data[i].group = data[i - 1].group;
          } else {
            this.spanArr.push(1);
            this.pos = i;
            data[i].group = data[i - 1].group + 1;
          }
        }
      }
    },
    //合并单元格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (!this.isSupportRowspan) {
        return;
      }
      if (columnIndex < this.spanColumns || column.label === "操作") {
        const _row = this.spanArr.length > 0 ? this.spanArr[rowIndex] : 0;
        const _col = _row > 0 ? 1 : 0;
        return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
          rowspan: _row,
          colspan: _col
        };
      }
    },
    cellClick(row, column) {
      if (row.isSupportCellEdit && column.property != "amount1") {
        row.isSupportCellEdit = false;
      } else if (!row.isSupportCellEdit && column.property == "amount1") {
        row["isSupportCellEdit"] = true;
      }
    },
    loseFcous(index, row) {
      row.isSupportCellEdit = false;
    },
    checkScopeBoxEnd(_value) {
      //let _value = this.$refs.scopeBoxInputEnd[0].value;
      _value = _value.replace(/^(0+)|[^\d]+/g, "");
      let start = this.$refs.scopeBoxInputStart[0].value;
      let tmpStart = parseFloat(start);
      let tmpValue = parseFloat(_value);
      if (tmpValue < tmpStart) {
        _value = tmpStart + 1;
      }
      this.queryForm._prop = _value;
    },
    checkScopeBoxStart(_value) {
      _value = _value.replace(/[^0-9.]/g, "");
      let end = this.$refs.scopeBoxInputEnd[0].value;
      let tmpEnd = parseFloat(end);
      let tmpValue = parseFloat(_value);
      if (tmpValue > tmpEnd) {
        _value = tmpEnd - 1;
      }
      return _value;
    }
    // cascaderChange(data) {
    //   setTimeout(function() {
    //     this.$emit('cascaderChange',{param:data});
    //   },200);
    // },
    // date2Change(data) {
    //   // console.log(data,'xuanze')
    //   // let time = data.join(',')
    //   // console.log(time,'time')
    //   this.$emit('date2Change',{param:data});
    // }
  },
  watch: {
    url(value, oldValue) {
      this.queryTable();
    },
    list: {
      handler(value) {
        if (this.allCheck) {
          this.list.forEach(row => {
            if (row) {
              this.$refs.queryTable.toggleRowSelection(row, true);
            }
            this.isSelected = true;
          });
        }
      },
      deep: true
    }
  },
  destroyed() {
    console.log("table destroyed");
    this.clearTimer();
  }
};
</script>

<style scoped lang="less">
@import "./index.less";
// /deep/.el-checkbox__input .is-checked + .el-checkbox__label {
//   color: #ff0000;
// }
</style>
<style>
.query-from-item label {
  font-size: 13px;
}
.STable .table .el-table th.is-leaf {
  border-bottom: 1px solid #ebeef5;
  background-color: #f5f7fa;
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/components/STable/index.vue